export default __webpack_public_path__ + "static/media/signout-icon.0d04bb56.png";